import { render, staticRenderFns } from "./PersonCreateDialog.vue?vue&type=template&id=06651e8f"
import script from "./PersonCreateDialog.vue?vue&type=script&lang=ts"
export * from "./PersonCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports